import styled from "styled-components";

interface IconTextWrapperProps {
  iconWidth?: string | number;
  iconHeight?: string | number;
}

export const IconTextWrapper = styled.div<IconTextWrapperProps>`
  .icon-text-wrapper {
    display: flex;
    flex: 1;
    align-items: center;
  }

  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: ${({ iconWidth }) => iconWidth || "auto"};
      height: ${({ iconHeight }) => iconHeight || "auto"};
      margin-right: 12px;
    }
  }
`;
